module.exports = __webpack_public_path__ + "img/best.480a0840.png";